export function AppFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t bg-gray-50/80 mt-auto">
      <div className="container mx-auto px-4 py-4 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="text-xs text-muted-foreground">
          © {year} TalentumIQ · Todos os direitos reservados
        </p>
        <p className="text-xs text-muted-foreground">
          Powered by <span className="font-medium text-foreground">Druid</span>
        </p>
      </div>
    </footer>
  );
}
